import dayjs from "dayjs";

export default function HorizontalNonLinearStepper({ onboardingStep, data }) {
  const { onboading_step_details } = data || {};

  console.log("onboading_step_details", onboading_step_details);

  return (
    <div className={`steps-form white-bg radius-20`}>
      {onboading_step_details ? (
        <p
          style={{ marginBottom: "1rem", fontSize: "1rem", fontWeight: "600" }}
        >
          המידע הנ״ל נכון לתאריך {onboading_step_details}
        </p>
      ) : null}
      <ul>
        <li
          className={
            onboardingStep >= 1
              ? `active${onboardingStep == 1 ? " current" : ""}`
              : ""
          }
        >
          <span className="count">1</span>
          <span className="text">ממתין לקבלת מידע אישי</span>
        </li>
        <li
          className={
            onboardingStep >= 2
              ? `active${onboardingStep == 2 ? " current" : ""}`
              : ""
          }
        >
          <span className="count">2</span>
          <span className="text">ממתין לקבלת מידע ביטוחי</span>
        </li>
        <li
          className={
            onboardingStep >= 3
              ? `active${onboardingStep == 3 ? " current" : ""}`
              : ""
          }
        >
          <span className="count">3</span>
          <span className="text">ממתין לקבלת מידע פיננסי</span>
        </li>
        <li
          className={
            onboardingStep >= 4
              ? `active${onboardingStep == 4 ? " current" : ""}`
              : ""
          }
        >
          <span className="count">4</span>
          <span className="text">התקבל מידע מגופי הפנסיה</span>
        </li>
        <li
          className={
            onboardingStep >= 5
              ? `active${onboardingStep == 5 ? " current" : ""}`
              : ""
          }
        >
          <span className="count">5</span>
          <span className="text">התקבל מידע מכלל הגופים</span>
        </li>
      </ul>

      <div className="progress-bar">
        <span style={{ width: `${onboardingStep * 20}%` }}></span>
      </div>
    </div>
  );
}
